let language = {
    ORDERS_ERROR_TIPS_FORM: "开始日期必须早于结束日期",
    ORDERS_ERROR_TIPS_NULL: "订购单表格为空",
    ORDERS_ERROR_TIPS_CANCEL_TITLE: "成功",
    ORDERS_ERROR_TIPS_CANCEL_CONTENT: "订单取消成功",
    ORDERS_ERROR_TIPS_DOWNLOAD_TITLE: "下载发票",
    ORDERS_ERROR_TIPS_DOWNLOAD_CONTENT: "没有选择项",
    ORDERS_ERROR_TIPS_DOWNLOAD_FAIL: "下载发票失败",
    ORDERS_ERROR_TIPS_DOWNLOAD_FAIL_TIPS: "找不到发票信息。请检查您的订单状态是否符合下载发票的条件。",
    ORDERS_ERROR_TIPS_DOWNLOAD_FAIL_TIPS_2: "有些订单没有发票信息。您可以点击 [确定] 继续下载发票，或点击 [取消] 停止下载。",
};

export { language }
